export default "__VITE_ASSET__BNVtr8T9__"